import styled, { css } from 'styled-components';

function getSize({ size }) {
    switch (size) {
        case 'md': {
            return css`
                width: 750px;
            `;
        }
        case 'sm': {
            return css`
                width: 450px;
            `;
        }
        default:
            return null;
    }
}

export const Wrapper = styled.div`
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 0 60px 0 rgba(29, 35, 55, 0.15);

    ${getSize};
`;

function titleSize({ cardSize, size }) {
    switch (cardSize || size) {
        case 'lg': {
            return css`
                height: 80px;
                padding: 5px 40px;

                button {
                    width: 52px;
                    height: 52px;
                    font-size: 20px;
                    margin-right: -20px;
                }
            `;
        }
        case 'sm': {
            return css`
                height: 55px;
                padding: 0 30px;

                button {
                    width: 52px;
                    height: 52px;
                    font-size: 20px;
                    margin-right: -20px;
                }
            `;
        }
        default:
            return css`
                height: 60px;
                padding: 5px 30px;

                button {
                    width: 52px;
                    height: 52px;
                    font-size: 20px;
                    margin-right: -20px;
                }
            `;
    }
}
export const Header = styled.div`
    ${titleSize};
    display: flex;
    align-items: center;
    color: var(--color-text-700);
    justify-content: space-between;
    border-bottom: 1px solid #e5ebf0;
    font-weight: ${({ childType }) => childType === 'string' && 600};

    button {
        border: 0;
        padding: 0;
        cursor: pointer;
        background: transparent;
    }
`;

function footerSize({ cardSize, size }) {
    switch (cardSize || size) {
        case 'lg': {
            return css`
                padding: 15px 40px 40px;
            `;
        }
        case 'sm': {
            return css`
                padding: 15px 25px 20px;
            `;
        }

        default:
            return css`
                padding: 15px 30px;
            `;
    }
}

export const Footer = styled.div`
    ${footerSize};
    border-top: 1px solid #e5ebf0;
`;

export const ModalBody = styled.div`
    ${({ size }) => {
        switch (size) {
            case 'sm':
                return 'padding: 30px';
            default:
                return 'padding: 30px';
        }
    }}
`;
